import React from 'react';
import Graphs from '../../utils/graphutil.js';
import $ from 'jquery';
import Containers from '../../utils/containerutil.js';
import { Container, ContainerArrowButton } from '../components.js';

class FIUsers extends React.Component {

	constructor(props) {
		super(props);

		this.getFIUserData = this.getFIUserData.bind(this);
		this.subviewClick = this.subviewClick.bind(this);

		this.state = { fi : {data :{}, dataError: false}};
		
		window._fiSponsor.loadSessionInfo();
	
	}

	componentDidMount() {
		
		if(this.state.fi.data !== null && Object.keys(this.state.fi.data).length === 0 && this.state.fi.dataError === false) {
			this.getFIUserData();
		}
	}

	componentDidUpdate() {
		var label1 = $('#pie-labels-0');
		var label2 = $('#pie-labels-1');

		if(label1.length && label2.length) {
			if($('#label0').length) {
				$('#label0').remove();
				$('#label1').remove();
			}
			//var superParent = label1.parent().parent().parent().parent().parent().parent();
			//var container = label1.parent().parent().parent().parent().parent();
			//var underline0 = '<div id="label0" class="PieLabel" style="width:' + label1[0].getBoundingClientRect().width + 'px; height:' + label1.height() + 'px;top:' + (label1.offset().top - container.offset().top) + 'px; left:' + (label1.offset().left - superParent.offset().left - label1[0].getBoundingClientRect().width * 0.1) + 'px;"></div>',
			//	underline1 = '<div id="label1" class="PieLabel" style="width:' + (label2[0].getBoundingClientRect().width * 1.5) + 'px; height:' + label2.height() + 'px;top:' + (label2.offset().top - container.offset().top) + 'px; left:' + (label2.offset().left - superParent.offset().left - label2[0].getBoundingClientRect().width * 0.1) + 'px;"></div>';

			//label1.parent().parent().after(underline0);
			//label2.parent().parent().after(underline1);
		}
	}

	getFIUserData() {
		var component = this;

		var callback = function(response) {
			if(response.detail !== "Report generated") {
				component.setState({fi : {data: response.data, dataError : response.detail}});
			}
			else {
				for(var i = 0; i !== response.data.fidata.length; i++) {
					var perc = response.data.fidata[i].percentage.toString();
					response.data.fidata[i].percentage = perc.slice(0, (perc.indexOf(".") + 3)) + '%';
				}
				component.setState({fi : {data : response.data, dataError: false}});
			}
		};

		window._fiSponsor.getFIUserData(callback);
	}

	subviewClick(e) {
		if(this.props.subviewClick) this.props.subviewClick(e);
	}

	render() {
		const fiContainerSize = {
			width: (this.props.size) ? this.props.size.width : '45.5vmin',
			height: (this.props.size) ? this.props.size.height : '30vmin'
		};

	  	var fiChart = Containers.getContainerDisplay(this.state.fi, Graphs.fi_users_pie, {key : 'summary'});

	  	const fiHeaderButton = (
	  		<ContainerArrowButton data-id={'fi'} onClick={this.subviewClick} />
	  		);

	  	const tooltipString = (window._fiSponsor.sponsors[0].name !== 'West Community Credit Union' && window._fiSponsor.sponsors[0].name !== 'Tigers Credit Union') ? "Non Customers are active users linked to an account at a different financial institution." : "Non Members are active users linked to an account at a different financial institution."
  		return (
  			<Container key='userfis' moreClass={"App-ChartsMore"} titles={[{'label' : 'User FI break down', 'onClick' : ''}]} button={fiHeaderButton} note={tooltipString} contents={fiChart} size={fiContainerSize} bgcolor='#48a7e3' />
  		);
	}
}

export default FIUsers;








